import { render, staticRenderFns } from "./ModalAddNewUser.vue?vue&type=template&id=4faf1168&scoped=true"
import script from "./ModalAddNewUser.vue?vue&type=script&lang=js"
export * from "./ModalAddNewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf1168",
  null
  
)

export default component.exports